import { IFieldDefinition } from "@entaconsulting/form";
import { SUPPORTED_SCHEMA_FIELDS_BY_TYPE } from "developer/edit/constants";
import { cloneDeep, isNil, isUndefined, pickBy, transform } from "lodash";

const generateFieldDefinition = (
  fieldDef: IFieldDefinition
): IFieldDefinition => {
  let newFieldDef = cloneDeep(fieldDef);

  if (newFieldDef.schema) {
    newFieldDef.schema = transform(newFieldDef.schema, (result, value, key) => {
      if (result) {
        result[key] = generateFieldDefinition(value);
      }
    });
  }

  if (newFieldDef.type === "select") {
    newFieldDef.type = "options";
  }

  if (
    ["options", "select"].includes(newFieldDef.type) &&
    isUndefined(newFieldDef.options)
  ) {
    newFieldDef.options = [];
  }

  if (Array.isArray(newFieldDef.blacklist)) {
    if (newFieldDef.type === "text") {
      newFieldDef.blacklist = newFieldDef.blacklist.map((x) => `${x}`);
    } else if (newFieldDef.type === "number")
      newFieldDef.blacklist = newFieldDef.blacklist
        .map((x) => (isNaN(+x) ? undefined : +x))
        .filter(Boolean);
  }

  if (Array.isArray(newFieldDef.whitelist)) {
    if (newFieldDef.type === "text") {
      newFieldDef.whitelist = newFieldDef.whitelist.map((x) => `${x}`);
    } else if (newFieldDef.type === "number")
      newFieldDef.whitelist = newFieldDef.whitelist
        .map((x) => (isNaN(+x) ? undefined : +x))
        .filter(Boolean);
  }

  const normalizedFieldDef = pickBy(
    newFieldDef,
    (value, key) =>
      !isNil(value) &&
      SUPPORTED_SCHEMA_FIELDS_BY_TYPE[fieldDef.type].includes(key)
  );

  return normalizedFieldDef as IFieldDefinition;
};

export default generateFieldDefinition;
